import { approvals } from './approvals.ts';
import { auth } from './auth.ts';
import { backoffice } from './backoffice.ts';
import { common } from './common.ts';
import { components } from './components.ts';
import { employee } from './employee.ts';
import { errors } from './errors.ts';
import { glossary } from './glossary.ts';
import { leaves } from './leaves.ts';
import { notifications } from './notifications.ts';
import { people } from './people.ts';
import { permissions } from './permissions.ts';
import { planning } from './planning.ts';
import { privacy } from './privacy.ts';
import { reports } from './reports.ts';
import { scheduling } from './scheduling.ts';
import { settings } from './settings.ts';
import { shell } from './shell.ts';
import { sites } from './sites.ts';
import { status } from './status.ts';
import { timesheet } from './timesheet.ts';
import { verification } from './verification.ts';
import { workorders } from './workorders.ts';

/** Tek dil: Türkçe (SK-09). Yazı yönü kataloğun parçasıdır; ikinci dil gelirse kendi yönüyle eklenir. */
export const catalogMeta = { locale: 'tr', dir: 'ltr' } as const;

export const messages = {
  common,
  components,
  glossary,
  errors,
  status,
  permissions,
  notifications,
  shell,
  auth,
  employee,
  approvals,
  people,
  leaves,
  timesheet,
  planning,
  scheduling,
  reports,
  privacy,
  sites,
  verification,
  workorders,
  settings,
  backoffice,
} as const;

export type Messages = typeof messages;
